'use client'

import { Breadcrumb } from '@/General/Breadcrumb'
import { H1 } from '@/General/H1'

function formatJobSlug(slug: string) {
  return slug
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

const JobApplicationHeader = ({ jobSlug }: JobApplicationHeaderProps) => {
  const formattedJobName = formatJobSlug(jobSlug)

  return (
    <div>
      <H1>Vanishing Inc. {formattedJobName}</H1>
      <Breadcrumb pages={[
        { name: 'Work for Vanishing Inc.', href: '/jobs/' },
        { name: `Vanishing Inc. ${formattedJobName}`, href: `/jobs/job/${jobSlug}/` },
        { name: 'Application', href: '#' },
      ]} className="mb-4" />
      <p className="lead mb-3">
        We aim to reply to all applications within 72 working hours. Please complete all info, and
        upload a resume including previous working history.
      </p>
    </div>
  )
}

export default JobApplicationHeader

interface JobApplicationHeaderProps {
  jobSlug: string
}
